module.exports = __webpack_public_path__ + "static/media/ppt-yd3.3034108d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/ppt-yd3.png
// module id = 1936
// module chunks = 6